import React from 'react'
import { NavLink } from 'react-router-dom'
import { Option, toRelativeUrl, decodeHTMLEntities } from '../../../helpers'
import { WordPress, withDataState } from '../../wordpress/wordpress_api'

type Props = {
  location: 'main' | 'footer' | 'recommended'
  hasActiveState: boolean
  before?: JSX.Element
  after?: JSX.Element
  cssClass?: string
  showDescription?: boolean
  onClick?: () => void
  hoveredItem?: WordPress.MenuItem
  onHoverItem?: (menuItemId: WordPress.MenuItem) => void
  onUnhoverItem?: () => void
}

type State = withDataState<WordPress.MenuLocationResponse>

export default class NavItems extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      kind: 'loading'
    }

  }

  componentDidMount() {
    WordPress.findMenuByLocation(this.props.location)
      .then(response => this.setState({ kind: 'loaded', data: Option(response.data) }))
      .catch(() => this.setState({ kind: 'error' }))
  }


  render() {
    let classes = [
      'nav__items',
      this.props.cssClass ? `nav__items--${this.props.cssClass}` : `nav__items--${this.props.location}`,
      this.props.hoveredItem ? 'nav__list--hover' : ''
    ]
    return (
      this.state.kind === 'loaded' &&
      this.state.data.kind === 'some' && (
        <ul className={classes.join(' ')}>
          {this.props.before}
          {this.state.data.value.map((menuItem: WordPress.MenuItem, index: number) => (
            <li
              className={`nav__item nav__item--${this.props.location} ${menuItem.classes} ${menuItem.children && menuItem.children.length > 0 ? 'has-children' : 'no-child'
                }`}
              key={`${this.props.location}-${index}`}
              onMouseEnter={_ => this.props.onHoverItem ? this.props.onHoverItem(menuItem) : null}
              // onFocus={_ => this.props.onHoverItem ? this.props.onHoverItem(menuItem) : null}
            >
              {menuItem.type == 'custom' ? (
                <a
                  href={menuItem.url}
                  onClick={() => this.props.onClick}
                  className={`nav__link nav__link--${this.props.location}`}
                  target={menuItem.target}
                >
                  <svg
                    className={`nav__icon${menuItem.children && menuItem.children.length > 0 ? '' : ' hide'}`}
                    width="8px"
                    height="5px"
                    aria-hidden="true"
                  >
                    <use xlinkHref="#icon--chevron" />
                  </svg>
                  <span className="nav__label">{decodeHTMLEntities(menuItem.title)}</span>
                </a>
              ) : (
                <NavLink
                  to={toRelativeUrl(menuItem.url)}
                  onClick={() => this.props.onClick}
                  className={`nav__link nav__link--${this.props.location}`}
                  activeClassName={this.props.hasActiveState ? 'nav__link--active' : null}
                >
                  <svg
                    className={`nav__icon${menuItem.children && menuItem.children.length > 0 ? '' : ' hide'}`}
                    width="8px"
                    height="5px"
                    aria-hidden="true"
                  >
                    <use xlinkHref="#icon--chevron" />
                  </svg>
                  <span className="nav__label">{decodeHTMLEntities(menuItem.title)}</span>
                </NavLink>
              )}
              {menuItem.children && menuItem.children.length > 0 ?
                <ul className="sublist">
                  {this.props.before}
                  {menuItem.children.map((menuItemChild: WordPress.MenuItem, index: number) => (
                    <li
                      className={`sublist__item`}
                      key={`${this.props.location}-${index}`}
                    >
                      <NavLink
                        to={toRelativeUrl(menuItemChild.url)}
                        onClick={() => this.props.onClick}
                        className={`sublist__link`}
                        activeClassName={this.props.hasActiveState ? 'sublist__link--active' : null}
                      >
                        <svg
                          className="subnav__icon"
                          width="8px"
                          height="5px"
                          aria-hidden="true"
                        >
                          <use xlinkHref="#icon--chevron" />
                        </svg>
                        <span className="subnav__label">{decodeHTMLEntities(menuItemChild.title)}</span>
                      </NavLink>
                    </li>
                  ))}
                  {this.props.after}
                </ul> : <></>
              }
            </li>
          ))}
          <li className="list__item nav__item nav__login--mobile">
            <a className="btn btn--primary" href="https://hypotrust.mijnleninginzicht.nl/" target="_blank">
              Mijn Hypotrust
            </a>
          </li>
          {this.props.after}
        </ul>
      )
    )
  }
}



// WEBPACK FOOTER //
// ./Client/components/public_site/templates/nav_items.tsx